// moz667: por culpa de vrdemo
var $ = jQuery;

window.datepicker_init = function () {
    $(".datepicker").each(function () {
        var $this = $(this);

        if ($this.data("birth_date")) {
            // FIXME: El rango de anios de la fecha de nacimiento esta puesto a
            // pelo... quizas ponerlo por config
            $this.datepicker({
                yearRange: "-120:-15",
                minDate: "-120Y",
                maxDate: "-15Y",
                changeMonth: true,
                changeYear: true
            });
        } else {
            $this.datepicker();
        }
    });
}
